import {Table} from "antd";
import {TrendBadge} from "./GscTrend";

/**
 * Bảng top query / top page. rows: [{value, clicks, impressions, ctr, position, delta_pct}].
 * `isPage`=true render value thành link (mở tab mới). ctr là tỉ lệ 0..1.
 * `showTrend`=true thêm cột "Thay đổi" (% so kỳ trước).
 */
function GscTopTable({rows = [], loading = false, isPage = false, label = 'Từ khoá', showTrend = false}) {

	const columns = [
		{
			title: label,
			dataIndex: 'value',
			key: 'value',
			ellipsis: true,
			render: (v) =>
				isPage
					? <a href={v} target="_blank" rel="noreferrer">{v}</a>
					: <span>{v}</span>,
		},
		{
			title: 'Clicks', dataIndex: 'clicks', key: 'clicks', width: 100, sorter: (a, b) => a.clicks - b.clicks,
			defaultSortOrder: 'descend',
			render: (v) => v.toLocaleString('vi-VN'),
		},
		...(showTrend ? [{
			title: 'Thay đổi', dataIndex: 'delta_pct', key: 'delta_pct', width: 110,
			render: (v) => <TrendBadge value={v} />,
		}] : []),
		{
			title: 'Impressions', dataIndex: 'impressions', key: 'impressions', width: 120, sorter: (a, b) => a.impressions - b.impressions,
			render: (v) => v.toLocaleString('vi-VN'),
		},
		{
			// Cột phụ — ẩn dưới 768px cho gọn màn nhỏ.
			title: 'CTR', dataIndex: 'ctr', key: 'ctr', width: 90, sorter: (a, b) => a.ctr - b.ctr,
			responsive: ['md'],
			render: (v) => `${(v * 100).toFixed(1)}%`,
		},
		{
			title: 'Vị trí', dataIndex: 'position', key: 'position', width: 90, sorter: (a, b) => a.position - b.position,
			render: (v) => v.toFixed(1),
		},
	];

	return (
		<Table
			rowKey="value"
			size="small"
			loading={loading}
			columns={columns}
			dataSource={rows}
			scroll={{x: 'max-content'}}
			pagination={{pageSize: 10, hideOnSinglePage: true, showSizeChanger: false}}
		/>
	);
}

export default GscTopTable;
